import { z } from "zod";

import { schemes } from "../schema-validation";
import { taskDefinitionInputSchema } from "../tasks/schemas/taskDefinitionSchema";
import { baseEventInput } from "./baseEvent";

export const whitelabelTaskDefinitionEvent = baseEventInput.merge(
  z.object({
    source: z.literal("whitelabel.task-definitions"),
    whiteLabelId: schemes.uuid(),
    payload: z.array(
      taskDefinitionInputSchema.pick({
        taskDefinitionId: true,
        enabled: true,
        default: true,
      })
    ),
  })
);

export type WhitelabelTaskDefinitionEvent = z.infer<
  typeof whitelabelTaskDefinitionEvent
>;
